import { Middleware } from 'redux'
import { NOTIFICATION_ACTION_TYPES } from './notification.constants'
import notificationService from './notification.service'
import notificationActions from './notification.actions'

// Not the nicest way to do this, but it works for now
import { BridgeListenerHandle } from 'features/NativePlugins/Bridges/BridgeListenerHandle'
import { currentNotificationListener } from './notification.selector'

export const setupNotificationListener: Middleware<unknown, {}, any> =
  (storeAPI: any) => (next) => (action) => {
    if (
      action.type ===
      NOTIFICATION_ACTION_TYPES.SETUP_NOTIFICATION_LISTENER_REQUEST
    ) {
      const success = (listener: BridgeListenerHandle) => {
        return {
          type: NOTIFICATION_ACTION_TYPES.SETUP_NOTIFICATION_LISTENER_SUCCESS,
          object: listener
        }
      }
      const failure = (error: any) => {
        return {
          type: NOTIFICATION_ACTION_TYPES.SETUP_NOTIFICATION_LISTENER_FAILURE,
          object: error
        }
      }

      const work = async () => {
        let listener = currentNotificationListener(storeAPI.getState())
        if (listener) {
          await listener.remove()
        }
        listener = await notificationService.setupNotificationListener()
        storeAPI.dispatch(success(listener))
      }

      work().catch((error) => {
        storeAPI.dispatch(failure(error))
      })
    }

    return next(action)
  }

export const checkNotificationAvailability: Middleware<unknown, {}, any> =
  (storeAPI: any) => (next) => (action) => {
    if (
      action.type ===
      NOTIFICATION_ACTION_TYPES.CHECK_NOTIFICATION_AVAILABILITY_REQUEST
    ) {
      const success = (isAvailable: boolean) => {
        return {
          type: NOTIFICATION_ACTION_TYPES.CHECK_NOTIFICATION_AVAILABILITY_SUCCESS,
          object: isAvailable
        }
      }
      const failure = (error: any) => {
        return {
          type: NOTIFICATION_ACTION_TYPES.CHECK_NOTIFICATION_AVAILABILITY_FAILURE,
          object: error
        }
      }

      try {
        storeAPI.dispatch(
          success(notificationService.canRequestNotifications())
        )
        storeAPI.dispatch(notificationActions.setupNotificationListener())
      } catch (e) {
        storeAPI.dispatch(failure(e))
      }
    }

    return next(action)
  }

export const requestRemoteNotification: Middleware<unknown, {}, any> =
  (storeAPI: any) => (next) => (action) => {
    if (
      action.type ===
      NOTIFICATION_ACTION_TYPES.REGISTER_REMOTE_NOTIFICATION_REQUEST
    ) {
      const success = () => {
        return {
          type: NOTIFICATION_ACTION_TYPES.REGISTER_REMOTE_NOTIFICATION_SUCCESS,
          object: action.channelSubdomains
        }
      }
      const failure = (error: any) => {
        return {
          type: NOTIFICATION_ACTION_TYPES.REGISTER_REMOTE_NOTIFICATION_FAILURE,
          object: error
        }
      }

      if (!notificationService.canRequestNotifications()) {
        storeAPI.dispatch(
          failure(new Error('Notifications is not available on this platform'))
        )
        return
      }

      notificationService.registerForPushNotifications().then(
        () => {
          storeAPI.dispatch(notificationActions.subscribeTo(action.object))
          storeAPI.dispatch(success())
        },
        (error: any) => {
          storeAPI.dispatch(failure(error))
        }
      )
    }
    return next(action)
  }

export const subscribeToTopic: Middleware<unknown, {}, any> =
  (storeAPI: any) => (next) => (action) => {
    if (action.type === NOTIFICATION_ACTION_TYPES.SUBSCRIBE_TO_TOPICS_REQUEST) {
      const success = (topics: string[]) => {
        return {
          type: NOTIFICATION_ACTION_TYPES.SUBSCRIBE_TO_TOPICS_SUCCESS,
          action: topics
        }
      }

      const failure = (error: any) => {
        return {
          type: NOTIFICATION_ACTION_TYPES.SUBSCRIBE_TO_TOPICS_FAILURE,
          action: error
        }
      }

      if (!notificationService.canRequestNotifications()) {
        storeAPI.dispatch(
          failure(new Error('Notifications is not available on this platform'))
        )
        return
      }

      Promise.all(notificationService.subscribeTo(action.object))
        .then((topics: string[]) => {
          storeAPI.dispatch(success(topics))
        })
        .catch((error) => {
          storeAPI.dispatch(failure(error))
        })
    }
    return next(action)
  }

export const unsubscribeFromTopic: Middleware<unknown, {}, any> =
  (storeAPI: any) => (next) => (action) => {
    if (
      action.type === NOTIFICATION_ACTION_TYPES.UNSUBSCRIBE_FROM_TOPICS_REQUEST
    ) {
      const success = (topics: string[]) => {
        return {
          type: NOTIFICATION_ACTION_TYPES.UNSUBSCRIBE_FROM_TOPICS_SUCCESS,
          action: topics
        }
      }

      const failure = (error: any) => {
        return {
          type: NOTIFICATION_ACTION_TYPES.UNSUBSCRIBE_FROM_TOPICS_FAILURE,
          action: error
        }
      }

      if (!notificationService.canRequestNotifications()) {
        storeAPI.dispatch(
          failure(new Error('Notifications is not available on this platform'))
        )
        return
      }

      Promise.all(notificationService.unsubscribeFrom(action.object))
        .then((topics: string[]) => {
          storeAPI.dispatch(success(topics))
        })
        .catch((error) => {
          storeAPI.dispatch(failure(error))
        })
    }
    return next(action)
  }
